import React from 'react';
import Card from 'react-bootstrap/Card';
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import { useState } from 'react';
import axios from 'axios';


function StatuseArbitrageCoach(props) {
    const [confirmation, setConfirmation] = useState(false);
    const [commentaireCoach, setCommentaireCoach] = useState();
    const [status, setStatus] = useState()
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const apiUrl = process.env.REACT_APP_API_URL;



    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setConfirmation(false);
  
        try {
          await axios.patch(`${apiUrl}/arbitrage/candidature/statut`, {
            idArbitre : props.status.id_arbitre,
            idMatch : props.status.id_match,
            commentaireCoach : commentaireCoach,
            statut : status
          }, {
            withCredentials: true
          });
    
          setError(null);
          setIsLoading(false);
          window.location.reload(); 
  
        } catch (error) {
          console.log(error)
          if (error.response) {
            setIsLoading(false)
            setError(error.response.data.message);
          } else {
            setIsLoading(false)
            setError(true);
          }
        }
      };
  
    
          if (isLoading) {
            return (
            <div className="centered-content">
              <img src="/img/logo.png" alt="Logo" className="centered-logo" />
              <br/>
              <span className="loader"></span>
            </div>
            
            );  
          }
          if(error){
              return (
                  <>
                  <div id="alert-message" className="alert4" >
                      <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
                  </div>
                </>  
              )
          }

  return (
    <>
    {confirmation && (
      <>
        <Modal show={confirmation} onHide={() => setConfirmation(false)}>
                <Modal.Header closeButton>
                  <Modal.Title>{status === 'modifier' ? ('Confirmer votre modification'):('Confirmer votre décision')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {status === 'modifier' ? ('Voulez-vous vraiment modifier votre commentaire pour cette candidature ?'):(`Voulez-vous vraiment ${status} cette candidature pour ce match ?`)}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary"  onClick={() => setConfirmation(false)} >
                    Quitter
                  </Button>
                  <Button variant="primary" onClick={(e) => handleSubmit(e)}  style={{backgroundColor:"#00E676", borderColor:'#00E676'}}  >
                    Confirmer
                  </Button>
                </Modal.Footer>
        </Modal>
      </>
    )}
    {props.status && (
        <>

            <Card.Body>
                <div className="nom" >
                    <Card.Title><a href={`/coach/equipe/arbitre/${props.status.id_arbitre}`} target="_blank" rel="noopener noreferrer"><span style={{textTransform : 'capitalize'}}>{props.status.nom} {props.status.prenom}</span></a></Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">{props.status.email} | {props.status.contact}</Card.Subtitle>
                </div>    
                <Card.Text>
                    <Form.Label>Commentaire de l'abitre</Form.Label>
                    <Form.Control as="textarea" disabled value={props.status.commentaire_arbitre} rows={3}  />
                    <Form.Label>Ajouter un commentaire</Form.Label>
                    <Form.Control as="textarea" value={props.status.commentaire_club !== null ? props.status.commentaire_club : commentaireCoach} onChange={(e) => setCommentaireCoach(e.target.value)} rows={3}  />
                </Card.Text>
                {props.status.status === 'en attente' && (
                    <>
                        <Button variant="primary" onClick={() => {setConfirmation(true);setStatus("accepter")}}  style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>Accepter </Button>
                        &nbsp;
                        <Button variant="secondary" onClick={() => {setConfirmation(true);setStatus("rejeter")}} >Rejeter </Button>
                    </>
                )}
                {props.status.status === 'rejeter' && (
                    <>
                        Vous avez <strong>rejeter</strong> cette candidature. Voulez-vous changer d'avis ? <br/><br/>
                        <Button variant="primary" onClick={() => {setConfirmation(true);setStatus("accepter")}}  style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>Accepter </Button>
                        &nbsp;
                        <Button variant="secondary" onClick={() => {setConfirmation(true);setStatus("modifier")}} >Modifier votre commentaire</Button>
                    </>
                )}
                {props.status.status === 'accepter' && (
                    <>
                        Vous avez <strong>accepter</strong> cette candidature. Voulez-vous changer d'avis ? <br/><br/>
                        <Button variant="primary" onClick={() => {setConfirmation(true);setStatus("rejeter")}} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>Rejeter </Button>
                        &nbsp;
                        <Button variant="secondary" onClick={() => {setConfirmation(true);setStatus("modifier")}} >Modifier votre commentaire</Button>
                    </>
                )}
                
            </Card.Body>
            <hr/>
            <br/>
        </>

    )  

    }


    </>
  );
}

export default StatuseArbitrageCoach;